"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _group = babelHelpers.interopRequireDefault(require("card/group"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _descriptor2, _temp;

var CustomGroupCard = (_class = (_temp =
/*#__PURE__*/
function (_GroupCard) {
  babelHelpers.inherits(CustomGroupCard, _GroupCard);

  function CustomGroupCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CustomGroupCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CustomGroupCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "customCard", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "customCardBody", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CustomGroupCard, [{
    key: "renderTileBody",
    value: function renderTileBody() {
      if (this.customCard) return _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.customCardBody
        }
      });
      return babelHelpers.get(babelHelpers.getPrototypeOf(CustomGroupCard.prototype), "renderTileBody", this).call(this);
    }
  }, {
    key: "renderTileFooter",
    value: function renderTileFooter() {
      if (this.customCard) return null;
      return babelHelpers.get(babelHelpers.getPrototypeOf(CustomGroupCard.prototype), "renderTileFooter", this).call(this);
    }
  }]);
  return CustomGroupCard;
}(_group.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "customCard", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "customCardBody", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = CustomGroupCard;